module.exports = __webpack_public_path__ + "img/xueli.063d4cbc.png";